import { dataCoinDiamondSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCoinDiamondSolid = /*#__PURE__*/createIcon(dataCoinDiamondSolid)
export default IconCoinDiamondSolid
